module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/examples/search-grid-format-example/search-grid-format-example.component.scss
// module id = ./src/app/components/examples/search-grid-format-example/search-grid-format-example.component.scss
// module chunks = main